import { API_ENDPOINTS } from '@config/api-endpoints';
import httpInstance from '@config/http';
import { BaseService } from './base.service';
/**
 * Authentication Service
 * Handles all authentication-related API calls
 */
class AuthService extends BaseService {
    /**
     * Authenticate user with external token
     * @param externalToken - External authentication token
     * @returns Authentication response with auth token
     * @throws ApiError if authentication fails
     */
    async authenticate(externalToken) {
        try {
            const request = { externalToken };
            const response = await httpInstance.post(API_ENDPOINTS.VOICE_RECORDINGS_AUTH, request);
            return response.data;
        }
        catch (error) {
            throw this.handleError(error, 'Failed to authenticate');
        }
    }
}
// Export singleton instance
export const authService = new AuthService();
